export const categories = [
  'Sweaters + Cardigans',
  'Sweatshirts + Hoodies',
  'Jackets + Coats',
  'Denim + Jeans',
  'Essentials',
  'Graphic Tees',
  'Shorts',
  'Activewear + Athletic',
  'Swimwear'
]
